import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors, useWatch } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { powerUnit, temperatureUnit } from '../../../../util/formatters'
import { ControlledSwitch } from '../../../form/ControlledSwitch'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function CoolingAirHeatPumpForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const freeCooling = useWatch<boolean>({
    control,
    name: 'parameters.coolingAirHeatPump.freeCooling',
  })

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.coolingAirHeatPump.eer"
          rules={{
            ...validators.required,
            ...validators.eer,
          }}
          error={errors.parameters?.coolingAirHeatPump?.eer}
          label={t('createProvider.forms.coolingAirHeatPump.eer')}
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.coolingAirHeatPump.maxPower"
          rules={{
            ...validators.required,
            ...validators.maxPower,
          }}
          error={errors.parameters?.coolingAirHeatPump?.maxPower}
          label={t('createProvider.forms.coolingAirHeatPump.maxPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>

      <FormGroup>
        <ControlledSwitch
          control={control}
          name="parameters.coolingAirHeatPump.freeCooling"
          label={t('createProvider.forms.coolingAirHeatPump.freeCooling')}
        />
      </FormGroup>

      {freeCooling && (
        <>
          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.coolingAirHeatPump.freeCoolingMaxOutdoorTemperature"
              rules={{
                ...validators.required,
                ...validators.decimal,
              }}
              error={
                errors.parameters?.coolingAirHeatPump
                  ?.freeCoolingMaxOutdoorTemperature
              }
              label={t(
                'createProvider.forms.coolingAirHeatPump.freeCoolingMaxOutdoorTemperature',
              )}
              InputProps={{
                endAdornment: <Typography>{temperatureUnit}</Typography>,
              }}
            />
          </FormGroup>

          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.coolingAirHeatPump.freeCoolingEer"
              rules={{
                ...validators.required,
                ...validators.eer,
              }}
              error={errors.parameters?.coolingAirHeatPump?.freeCoolingEer}
              label={t(
                'createProvider.forms.coolingAirHeatPump.freeCoolingEer',
              )}
            />
          </FormGroup>

          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.coolingAirHeatPump.freeCoolingMaxPower"
              rules={{
                ...validators.required,
                ...validators.maxPower,
              }}
              error={errors.parameters?.coolingAirHeatPump?.freeCoolingMaxPower}
              label={t(
                'createProvider.forms.coolingAirHeatPump.freeCoolingMaxPower',
              )}
              InputProps={{
                endAdornment: <Typography>{powerUnit}</Typography>,
              }}
            />
          </FormGroup>
        </>
      )}
    </>
  )
}
